import { useState } from "react";
import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import Session from "@lib/session";
import CreditCards from "./CreditCards";
import Valpay from "@hudson/ui/components/Valpay";
import useConfig from "@lib/use_config";
import userProfileAddValpayCc from "@lib/services/user_profile_add_valpay_cc";
import userProfileDeleteCc from "@lib/services/user_profile_delete_cc";
import Error from "@hudson/ui/components/Error";
import useContent from "@lib/use_content";
import { useUserProfileQuery, useValpayConfigQuery } from "@graphql/api";

export default function Payment() {
  const { data, loading, error } = useValpayConfigQuery();
  const {
    data: cfgData,
    loading: cfgLoading,
    error: cfgError,
  } = useConfig(["defaultCcProcessorId", "shopperReference"]);
  const {
    data: cData,
    loading: cLoading,
    error: cError,
  } = useContent(["beErrProfileCcAdd", "beErrProfileCcRemove", "beProfileCcAddSubmitButton"]);
  const [valpaySeed, setValpaySeed] = useState(1); // Used to reload ValPay component
  const [errorMessage, setError] = useState("");

  const {
    data: profileData,
    loading: profileLoading,
    error: profileError,
  } = useUserProfileQuery({ variables: { id: Session.getBooking().profiles.user } });

  if (error || profileError || cError) {
    console.error(error, profileError, cError);
    return null;
  }

  async function onDelete(id: string): Promise<boolean> {
    const userId = Session.getBooking().profiles.user;
    if (!userId) {
      console.error("No user ID found in session.");
      setError(cData?.content.beErrProfileCcRemove);
      return false;
    }
    const result = await userProfileDeleteCc(userId, undefined, id);
    if (!result) setError(cData?.content.beErrProfileCcRemove);
    return result;
  }

  async function onSubmit({
    name,
    token,
    encryptedCardNumber,
    encryptedExpiryMonth,
    encryptedExpiryYear,
    encryptedSecurityCode,
    postalCode,
  }) {
    setError("");
    const result = await userProfileAddValpayCc(
      Session.getBooking().profiles.user,
      encryptedCardNumber,
      encryptedExpiryMonth,
      encryptedExpiryYear,
      encryptedSecurityCode,
      name,
      postalCode,
    );
    if (!result) setError(cData?.content.beErrProfileCcAdd);
    setValpaySeed(valpaySeed + 1);
  }

  let content;
  if (data?.valpayConfig.enabled) {
    content = (
      <>
        <Error className="mt-8" message={errorMessage} heavyStyle />
        <Valpay
          key={valpaySeed}
          buttonLabel={cData?.content.beProfileCcAddSubmitButton}
          className="mt-8"
          processorId={cfgData?.config.defaultCcProcessorId}
          profileMode={true}
          onDelete={onDelete}
          onSubmit={onSubmit}
          shopperReference={
            Session.getBooking().payment?.shopperReference || cfgData?.config.shopperReference
          }
        />
      </>
    );
  } else {
    content = <CreditCards cards={profileData?.userProfile?.creditCards} />;
  }

  return (
    <>
      {loading || profileLoading || cfgLoading || cLoading ? (
        <ConcentricLoader className="opacity-60 max-w-2xl mx-auto  px-4 sm:py-10 sm:px-6 lg:px-8" />
      ) : (
        content
      )}
    </>
  );
}
